import { render, staticRenderFns } from "./RiskUpload.vue?vue&type=template&id=1274ba96"
import script from "./RiskUpload.vue?vue&type=script&lang=js"
export * from "./RiskUpload.vue?vue&type=script&lang=js"
import style0 from "./RiskUpload.vue?vue&type=style&index=0&id=1274ba96&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports